<template>
  <v-layout row wrap class="pt-2">
    <v-flex xs12 md6 v-if="hasResumeTables">
      <v-card flat class="ma-1 card-rounded">
        <v-card-title> Tabelas Resumo </v-card-title>

        <v-list class="pt-0">
          <v-divider />
          <template v-for="(item, key) in resumeTables">
            <v-list-tile
              ripple
              @click="setResumeTable(null, 'table', 'resume', item.value)"
              v-if="
                selectedLogbook === item.logbook &&
                speciality === item.specialty
              "
              :key="item.value"
            >
              <Icon name="table" size="16" class="mr-1" />
              <span class="body-1">{{ item.label }}</span>
            </v-list-tile>
            <v-divider
              v-if="
                selectedLogbook === item.logbook &&
                speciality === item.specialty
              "
              :key="item.value + key"
            />
          </template>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex xs12 md6 v-for="item in allData" :key="item.component">
      <v-card flat class="ma-1 card-rounded">
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="editTable(item.component, item.type, 'variables')"
            icon
            small
          >
            <Icon name="edit" size="14" />
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <h4
            class="font-weight-regular mb-2"
            v-text="charTitle(item.component)"
          />
          <Table2by2
            v-if="item.type === 'table'"
            :logs="logs"
            :statsData="statsData(selectedLogbook, item.type, item.component)"
          />
          <PieChart
            v-else-if="item.type === 'pie'"
            :logs="logs"
            height="250"
            width="100%"
            :statsData="statsData(selectedLogbook, item.type, item.component)"
          />
          <BarChart
            v-else-if="item.type === 'bar'"
            :logs="logs"
            height="100%"
            width="80%"
            :statsData="statsData(selectedLogbook, item.type, item.component)"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import helpers from '../mixins/statsHelperFunc'
import Table2by2 from '../tables/Table2by2.vue'
import PieChart from '../charts/PieChart.vue'
import BarChart from '../charts/BarChart.vue'
export default {
  props: {
    selectedLogbook: { type: String },
    logs: { type: Array },
    resumeTables: { type: Array }
  },
  mixins: [helpers],
  components: {
    Table2by2,
    PieChart,
    BarChart
  },
  data() {
    return {
      speciality: this.$store.getters.specialty
    }
  },
  computed: {
    allData() {
      const newData = this.statComponents.filter(item => {
        return (
          item.logbooks.includes(this.selectedLogbook) &&
          !Array.isArray(item.favourite)
        )
      })
      const items = newData.map(item => {
        return {
          component: item.id,
          type: item.favourite
        }
      })
      return items
    },
    statComponents() {
      if (this.selectedLogbook) {
        return this.allStatsComponents(this.selectedLogbook)
      } else {
        return []
      }
    },
    hasResumeTables() {
      var show = false

      this.resumeTables.forEach(item => {
        item.logbook === this.selectedLogbook &&
        item.specialty === this.speciality
          ? (show = true)
          : ''
      })

      return show
    }
  },
  methods: {
    statsData(logbook, type, component) {
      return {
        logbookType: logbook,
        selectedDisplayMode: type,
        tableType: 'variables',
        variables: {
          row1: this.statComponents.filter(item => item.id === component)[0]
        }
      }
    },
    setResumeTable(component, displayMode, display, resumeTable) {
      this.$root.$emit('displayGraph', {
        component: component,
        displayMode: displayMode,
        display: display,
        resumeTable: resumeTable
      })
    },
    charTitle(component) {
      const selectedComponent = this.statComponents.filter(
        item => item.id === component
      )[0]
      if (selectedComponent) {
        return selectedComponent.label
      }
      return component
    },
    editTable(component, displayMode, display) {
      this.$root.$emit('displayGraph', {
        component: component,
        displayMode: displayMode,
        display: display
      })
    }
  }
}
</script>

<style></style>
